import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableStopPicking = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableStopPicking);
};
